import { createSelector } from 'reselect';
import { getIsBookedOrConfirmed } from '../order/selectors';
const getState = (state) => state.formIsLocked;
export const isFormLocked = createSelector(getState, getIsBookedOrConfirmed, (isLocked, isBooked) => isLocked && !isBooked);
